import MicroModal from 'micromodal'
import { playVideo, stopVideo } from './videos'

export default function() {
    MicroModal.init({
        onShow: playVideo,
        onClose: stopVideo,
    })
}